<template>
  <div v-show="!loading">
    <wa-message
      v-if="success"
      theme="success"
      icon-name="faFaceSmile"
      type="flash"
      :custom-style="{
        '--message-margin': ' var(--spacing-lg) 0 0 0'
      }"
    >
      <template slot="content">
        <strong>You made something awesome!</strong>&nbsp; Visit your Kit to
        <site-link
          :to="{ name: 'kits.kit.customicons', params: { token: selectedKit, icon: iconName } }"
          class="link fa-navy"
          @click.native="$posthog.capture('icon_wizard_view_new_icon_link_click')"
        >
          view your new icon
        </site-link>
        .
      </template>
    </wa-message>

    <wa-message
      v-if="isSignedIn && isPro && !hasKits"
      theme="danger"
      icon-name="faExclamationTriangle"
      :custom-style="{
        '--message-margin': ' var(--spacing-lg) 0 0 0'
      }"
    >
      <template slot="content">
        No Kits found. Go
        <site-link
          :to="{ name: 'kits' }"
          class="link fa-navy"
        >
          create a Kit
        </site-link>
        and give it another try.
      </template>
    </wa-message>

    <wa-message
      v-if="duplicateError"
      theme="warning"
      icon-name="faExclamationTriangle"
      type="flash"
      :custom-style="{
        '--message-margin': ' var(--spacing-lg) 0 0 0'
      }"
    >
      <template slot="content">
        You already have that
        <site-link
          :to="{ name: 'kits.kit.icons', params: { token: selectedKit, icon: iconName } }"
          class="link fa-navy"
        >
          icon
        </site-link>
        in the Kit you selected!
      </template>
    </wa-message>

    <wa-message
      v-if="errorMessage != ''"
      theme="danger"
      icon-name="faSkullCrossbones"
      type="flash"
      :custom-style="{
        '--message-margin': ' var(--spacing-lg) 0 0 0'
      }"
    >
      <template slot="content">
        {{ errorMessage }}
      </template>
    </wa-message>
  </div>
</template>

<script>
  export default {
    name: 'CustomizeAlerts',

    props: {
      errorMessage: {
        type: String
      },
      kits: {
        type: Array
      },
      duplicateError: {
        type: Boolean,
        default: false
      },
      iconName: {
        type: String
      },
      selectedKit: {
        type: String
      },
      success: {
        type: Boolean,
        default: false
      },
      loading: {
        type: Boolean,
        default: true
      }
    },

    computed: {
      isSignedIn() {
        return this.$route.meta.isSignedIn
      },

      isPro() {
        return this.$dt.isPro
      },

      hasKits() {
        return this.kits && this.kits.length > 0
      }
    }
  }
</script>
